require('./aresLoansMortgagesModal.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
// @core
const { formatText, FormattedText } = require('core/i18n').i18n;
// @commons
const OKModal = require('components/commons/OKModal/OKModal');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @components
const ContractLoanPdfViewerError = require('../../../components/contracts/contractLoanPdfViewerError/contractLoanPdfViewerError');
// @constants
const translations = require('./aresLoansMortgagesModal.translations');
// @utilities
const BrowserUtils = require('utilities/browserUtils');
const { downloadAsFile } = require('utilities/APIRequestHelper');
const { recordLinkV2, PAGE_ARES_LOANS_MORTGAGES_CONTRACT } = require('utilities/tagging');

class AresLoansMortgagesModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            scrollFinalDone: false,
            viewerHeightModal: 'auto',
        };

        this.handlePrintDocuments = this.handlePrintDocuments.bind(this);
        this.handleDownloadDocuments = this.handleDownloadDocuments.bind(this);
        this.getSize = this.getSize.bind(this);
    }

    getSize(height) {
        this.setState({ viewerHeightModal: height - 64 });
    }

    handlePrintDocuments() {
        recordLinkV2({ categoriaEvento: PAGE_ARES_LOANS_MORTGAGES_CONTRACT, accionEvento: "clickPrint", etiquetaEvento: "legalContract" });

        const { documents } = this.props;
        const data = [new Uint8Array(documents)];
        const blobObject = new Blob(data, { type: 'application/pdf' });

        if (BrowserUtils.browserIsIE()) {
            window.navigator.msSaveOrOpenBlob(blobObject);
        } else {
            const blobURL = window.URL.createObjectURL(blobObject);
            const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
                'resizable,screenX=50,screenY=50,width=850,height=1050';
            const printWindow = window.open(blobURL, '', winparams);

            if (printWindow) {
                printWindow.print();
            }
        }
    }

    handleDownloadDocuments(filename = 'Autorizacion_Consulta_TGSS.pdf') {
        const { documents } = this.props;
        recordLinkV2({ categoriaEvento: PAGE_ARES_LOANS_MORTGAGES_CONTRACT, accionEvento: "clickButton", etiquetaEvento: "downloadLegalContractButton" });
        downloadAsFile(documents, 'application/pdf', filename);
    }

    buildContent() {
        const {
            immScreen, documents, isFetching, error,
            getDocuments,
        } = this.props;
        const { viewerHeightModal } = this.state;

        if (isFetching) {
            return <LoadingSection />;
        }

        return (
            <OKPdfViewer
                title={formatText(translations.PDF_VIEWER_TITLE)}
                pdfFile={documents}
                onDownload={this.handleDownloadDocuments}
                onPrint={this.handlePrintDocuments}
                displayScrollButton
                showScroll
                scale={immScreen && (immScreen.get('isTablet') || immScreen.get('isMobile')) ? 1.2 : 1.5}
                viewerHeight={viewerHeightModal}
                onDocumentReaded={() => this.setState({ scrollFinalDone: true })}
                failedLoadingPdf={error}
                errorComponent={() => {
                    return <ContractLoanPdfViewerError getDocuments={getDocuments} />
                }}
            />
        );
    }

    buildFooterContent() {
        const { scrollFinalDone } = this.state;

        return (
            <React.Fragment>
                {scrollFinalDone && (
                    <FormattedText value={translations.PDF_VIEWER_FOOTER} />
                )}
            </React.Fragment>
        );
    }

    render() {
        const { immScreen, isOpenModal, onCloseModal } = this.props;
        const { scrollFinalDone } = this.state;

        const content = this.buildContent();
        const footerContent = this.buildFooterContent();

        return (
            <OKModal
                isOpen={isOpenModal}
                title={formatText(translations.MODAL_TITLE)}
                onCloseCallback={() => onCloseModal("salir")}
                content={content}
                contentOverflow={'hidden'}
                footerType={'navigation'}
                contentFooter={footerContent}
                getSize={this.getSize}
                noContentScroll
                size={immScreen && (immScreen.get('isTablet') || immScreen.get('isMobile')) ? 'full-screen' : 'extra-large'}
                onPrimaryButtonClick={() =>  onCloseModal("continuar")}
                primaryButtonText={formatText(translations.MODAL_CONTINUE_BUTTON)}
                primaryButtonDisabled={!scrollFinalDone}
                onSecondaryButtonClick={() => onCloseModal("cancelar")}
                secondaryButtonText={formatText(translations.MODAL_CANCEL_BUTTON)}
                overlayClassName={`ares-loans-mortgages-modal__${scrollFinalDone ? 'show' : 'hide'}-footer`}
            />
        );
        
    }
}

AresLoansMortgagesModal.propTypes = {
    // Modal
    isOpenModal: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    // document info
    documents: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
    error: PropTypes.object.isRequired,
    getDocuments: PropTypes.func.isRequred,
    // screen
    immScreen: PropTypes.object.isRequired,
};

AresLoansMortgagesModal.defaultProps = {
    isFetching: false,
    error: undefined,
    getDocuments: () => {},
};


module.exports = connect(state => ({ immScreen: state.screen, }), null)(AresLoansMortgagesModal);